<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import StatisticWidget from '@/onenetwork/components/widgets/StatisticWidget.vue'
import DeviceChart from '@/modules/statistic/components/DeviceChart.vue'
import UsageChart from '@/modules/statistic/components/UsageChart.vue'
import UsageGenderChart from '@/modules/statistic/components/UsageGenderChart.vue'
import UsageRegionChart from '@/modules/statistic/components/UsageRegionChart.vue'
</script>

<template>
  <dashboard-layout currentRoute="reports/transactions" page-title="Thống kê • Giao dịch ">
    <div class="flex flex-col md:flex-row gap-3">
      <statistic-widget
        icon="fa6-solid:user-plus"
        title="Đăng ký hôm nay"
        :current-value="30"
        value-unit=""
        :growth-value="2"
        growth-value-unit="%"
        growth-description="so với hôm qua"
      />
      <statistic-widget
        icon="fa6-solid:user-plus"
        title="Đăng ký tháng này"
        :current-value="30"
        value-unit=""
        :growth-value="-20"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
      <statistic-widget
        icon="jam:android-circle"
        title="Lượt tải Android"
        :current-value="30"
        value-unit=""
        :growth-value="20"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
      <statistic-widget
        icon="jam:apple-circle"
        title="Lượt tải iOS"
        :current-value="30"
        value-unit=""
        :growth-value="50"
        growth-value-unit="%"
        growth-description="so với tháng trước"
      />
    </div>

    <div class="flex flex-col md:flex-row mt-5 gap-3">
      <div class="flex-1 md:flex-3">
        <div class="flex w-full md:flex-row gap-3">
          <Panel header="Biểu đồ theo thiết bị" class="flex-1 mb-5" toggleable>
            <UsageChart/>
          </Panel>
          <Panel header="Biểu đồ theo giới tính" class="flex-1 mb-5" toggleable>
            <UsageGenderChart/>
          </Panel>
        </div>
        <div class="w-full">
          <Panel header="Biểu đồ theo giới tính" class="flex-1 mb-5" toggleable>
            <UsageRegionChart/>
          </Panel>
        </div>
      </div>
      <div class="flex-1 md:flex-1">
        <Panel header="Biểu đồ tỉ lệ tổng sử dụng theo thiết bị" class="mb-5" toggleable>
          <div class="flex w-full justify-center">
            <DeviceChart/>
          </div>
        </Panel>
        <Panel header="Biểu đồ tỉ lệ tổng đăng ký theo khu vực" toggleable>
          <div class="flex w-full justify-center">
            <DeviceChart/>
          </div>
        </Panel>
      </div>
    </div>

  </dashboard-layout>
</template>

<style scoped>

</style>
